module.exports = __webpack_public_path__ + "assets/img/246801.de4d1ea4.png";